export default __webpack_public_path__ + "static/media/values4.d82c48c7.png";